import { isNil } from 'ramda';

const isInRange = (val, { min, max }) => {
  if (val > min && val <= max) {
    return true;
  }
  return false;
};

const scoresMap = [
  { letter: 'A', max: 4, min: 3.5 },
  { letter: 'B+', max: 3.5, min: 3 },
  { letter: 'B', max: 3, min: 2.5 },
  { letter: 'C+', max: 2.5, min: 2 },
  { letter: 'C', max: 2, min: 1.5 },
  { letter: 'D+', max: 1.5, min: 1 },
  { letter: 'D', max: 1, min: 0 },
];

export const gradeLettersInsteadOfScore = (score) => {
  const arrayWithLetter = scoresMap.map(({ letter, ...range }) => {
    if (isInRange(score, range)) {
      return letter;
    }
  });

  return arrayWithLetter.filter((item) => !isNil(item))[0];
};
